import { bindActionCreators } from 'redux';

export const PHONE_CONFIRMED = 'PHONE/PHONE_CONFIRMED';
export const PHONE_CHANGE = 'PHONE/PHONE_CHANGE';
export const PHONE_CHANGE_CONFIRMED = 'PHONE/PHONE_CHANGE_CONFIRMED';
export const PHONE_SEND = 'PHONE/PHONE_SEND';
export const CODE_SEND = 'PHONE/CODE_SEND';
export const PHONE_SET_EXPECTED_CODE = 'PHONE/PHONE_SET_EXPECTED_CODE';

export const phoneComfrimation = () => ({
  type: PHONE_CONFIRMED
});

export const phoneSend = (callback, isSignIn) => ({
  type: PHONE_SEND,
  payload: { callback, isSignIn }
});

export const codeSend = (callback, isSignIn) => ({
  type: CODE_SEND,
  payload: { callback, isSignIn }
});

export const setExpectedCode = expectedCode => ({
  type: PHONE_SET_EXPECTED_CODE,
  payload: { expectedCode }
});

const phoneChange = (phone, purePhone) => ({
  type: PHONE_CHANGE,
  payload: { phone, purePhone }
});

const phoneCodeConfirmChange = (phoneCodeConfirm = ['']) => ({
  type: PHONE_CHANGE_CONFIRMED,
  payload: { phoneCodeConfirm }
});

function containerActions(dispatch) {
  return bindActionCreators(
    {
      phoneComfrimation,
      phoneChange,
      phoneSend,
      codeSend,
      phoneCodeConfirmChange
    },
    dispatch
  );
}

export default containerActions;



// WEBPACK FOOTER //
// ./src/pages/Phone/actions.js